require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-dusty-simmons.json") })
        }
      }, "path---articles-tags-dusty-simmons");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-dusty-simmons!./.cache/json/articles-tags-dusty-simmons.json
// module id = 1804
// module chunks = 231608221292675